var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        { attrs: { title: "Explicación y justificación del contrato" } },
        [
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required:
                      "Debe indicar por qué el DEPR no puede proveer el servicio."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label:
                                "¿Por qué el Departamento de Educación de Puerto Rico no puede proveer los servicios? Los servicios profesionales solo se deben contratar si el Departamento de Educación de Puerto Rico no tiene los recursos internos necesarios o especializados para brindarlos.",
                              maxlength: 10000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model,
                              callback: function($$v) {
                                _vm.model = $$v
                              },
                              expression: "model"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  374111814
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(
                    " ¿Por qué el Departamento de Educación de Puerto Rico no puede proveer los servicios? Los servicios profesionales solo se deben contratar si el Departamento de Educación de Puerto Rico no tiene los recursos internos necesarios o especializados para brindarlos. "
                  )
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(" " + _vm._s(_vm._f("empty")(_vm.model)) + " ")
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }